export default function LoadingIcon() {
    return (
        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    )
}